/* Honeypot — invisible field used to trap auto-fill bots.
 *
 * - Rendered off-screen + aria-hidden + tabIndex=-1 so real users (incl.
 *   screen-reader + keyboard users) never see or focus it.
 * - Bots that scrape the form and auto-fill every text input will populate
 *   it; the backend rejects any submission where `website` is non-empty.
 * - Keep the `name="website"` on the wire — common bot heuristics target
 *   that label specifically.
 */
import React from "react";

export default function Honeypot({ value, onChange, name = "website" }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: 1,
        height: 1,
        overflow: "hidden",
      }}
    >
      <label htmlFor={`hp-${name}`}>Website (leave blank)</label>
      <input
        id={`hp-${name}`}
        type="text"
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
      />
    </div>
  );
}
